import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getNew = createAsyncThunk(
  "NewsView/getNew",
  async (params, { rejectWithValue }) => {
    try {
      params.token = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/News/getNew`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getNews = createAsyncThunk(
  "News/getNews",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/News/getNews`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveNew = createAsyncThunk(
  "News/saveNew",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/News/saveNew`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
